export default __webpack_public_path__ + "static/media/dia13.15dda6d8.png";